<script setup>
import LoginForm from '@/components/login/LoginForm.vue'
import loginBgImage from '@images/pages/login-bg.jpg'
import LoginHeader from '@/components/login/LoginHeader.vue'

definePage({
  meta: {
    layout: 'blank',
  },
})
</script>

<template>
    <LoginHeader />
  <VRow
    no-gutters
    class="auth-wrapper login-page-bg"
    :style="{ backgroundImage: `url(${loginBgImage})` }"
  > 
    <LoginForm />
    <VCol
      md="7"
      class="d-none d-md-flex"
    />
  </VRow>
</template>

<style lang="scss">
@use '@core/scss/template/pages/page-auth.scss';

.auth-wrapper.login-page-bg {
  min-height: 100vh;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
